
export const RANKS = {
  MASTER: 'master',
  DIAMOND: 'diamond',
  PLATINUM: 'platinum',
  GOLD: 'gold',
  SILVER: 'silver',
  BRONZE: 'bronze',
};
export const ORDERED_RANKS = [
  RANKS.MASTER,
  RANKS.DIAMOND,
  RANKS.PLATINUM,
  RANKS.GOLD,
  RANKS.SILVER,
  RANKS.BRONZE,
];
export const RANK_POINTS = {
  [RANKS.MASTER]: 5000,
  [RANKS.DIAMOND]: 4000,
  [RANKS.PLATINUM]: 3000,
  [RANKS.GOLD]: 2000,
  [RANKS.SILVER]: 1000,
  [RANKS.BRONZE]: 0,
};

export const pointsToRank = (points) => {
  if (!points && points !== 0) {
    return;
  }
  for (const rank of ORDERED_RANKS) {
    if (points >= RANK_POINTS[rank]) {
      return rank;
    }
  }
};
